import { logout } from '../../operations/logout'
import { fail } from '../fail'
import { say, section } from '../output'
import { reportLogout } from '../reporter'

export async function logoutCommand(): Promise<void> {
  try {
    const result = await logout({ onEvent: reportLogout })

    // "Not logged in." rather than a success line: nothing was revoked and nothing was cleared, and saying
    // otherwise would suggest a token had just been thrown away.
    if (result.wasLoggedIn) {
      section('  Logged out successfully.')
    } else {
      say('Not logged in.')
    }
  } catch (error) {
    fail(error)
  }
}
